import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ProductSummaryProduct from './ProductSummaryProduct';
import { isValid, decodeSpecialCharacters, scrollToTopOf } from '../../../../utils';
import './product-summary.scss';
import Button from '../../../common/Button';

const ProductSummary = ({ data, isMobile, productSummary, isAffiliate }) => {
  if (!isValid(data) || !isValid(productSummary)) {
    return null;
  }

  const showButton = productSummary.length > 5;
  const [showMore, setShowMore] = useState(false);

  const renderedProducts = (
    <div className="products">
      {productSummary.map((product, i) => {
        if (i < 5 || showMore) {
          return <ProductSummaryProduct product={product} i={i} isMobile={isMobile} isAffiliate={isAffiliate} hidden={false} />;
        } else {
          return <ProductSummaryProduct product={product} i={i} isMobile={isMobile} isAffiliate={isAffiliate} hidden={true} />;
        }
      })}
    </div>
  );

  const prodSummaryRef = useRef();

  const handleScroll = () => {
    scrollToTopOf(prodSummaryRef.current, 80, 20);
  };

  return (
    <div className="product-summary" ref={prodSummaryRef} id="product-summary">
      <div className="product-summary-title" dangerouslySetInnerHTML={{ __html: decodeSpecialCharacters(data) }}></div>
      {renderedProducts}
      {showButton &&
        <p className="show-more-button" onClick={() => { setShowMore(!showMore); if (showMore) { handleScroll(); } }}>
          Show {showMore ? 'Less' : 'More'}
        </p>
      }
    </div>
  );
};

ProductSummary.propTypes = {
  data: PropTypes.array,
};

export default ProductSummary;
